import React, {Fragment, Component} from 'react';
import {
    Input,
    InputGroup,
    InputGroupAddon,
    Button,
    Col, Row,
    Label
} from 'reactstrap'
import {connect} from 'react-redux';
import autobind from 'autobind-decorator'

@connect(
    state => ({
    }),
    dispatch => ({

    })
)
export default class Question extends Component {

    @autobind
    save() {
        this.props.save();
    }

    @autobind
    toggleAnswers() {
        this.props.setOpenQuestion(this.props.dkey)
    }

    @autobind
    updateQuestion(e) {
        const {value, name} = e.target;
        const {question, updateQuestion} = this.props;
        updateQuestion({
            ...question,
            [name]: value
        })
    }

    @autobind
    deleteQuestion() {
        const {deleteQuestion} = this.props;
        deleteQuestion();
    }

    @autobind
    addNewAnswer() {
        const {question, updateQuestion} = this.props;
        const {answers} = question;
        updateQuestion({
            ...question,
            answers: [...answers, {
                text: 'Neue Antwort',
                correct: true,
                idx: answers.length + 1
            }]
        })
    }

    @autobind
    deleteAnswer(answer) {
        const answerList = this.props.question.answers.filter(
            aa => aa.idx !== answer.idx
        )
        this.props.updateQuestion({
            ...this.props.question,
            answers: answerList.map(
                (answer, idx) => ({
                    ...answer,
                    idx: idx + 1
                })
            )
        })
        this.save()
    }

    @autobind
    updateAnswerText(answer, e) {
        const answerList = this.props.question.answers.map(
            aa => aa.idx === answer.idx ? {...answer, text: e.target.value} : aa
        )
        this.props.updateQuestion({
            ...this.props.question,
            answers: answerList
        })
    }

    @autobind
    toggleAnswerCorrectness(answer, correct) {
        const answerList = this.props.question.answers.map(
            aa => aa.idx === answer.idx ? {...answer, correct: correct} : aa
        )
        this.props.updateQuestion({
            ...this.props.question,
            answers: answerList
        })
        this.save()
    }

    render() {
        const {question} = this.props;
        const isOpen = this.props.dkey === this.props.openQuestion();
        return (
            <Fragment>
                <br/>
                <InputGroup>
                    <InputGroupAddon addonType='prepend'>
                        <Button color='primary' onClick={this.toggleAnswers}>
                            {question.idx}.
                        </Button>
                    </InputGroupAddon>
                    <Input
                        type="textarea"
                        value={question.text}
                        name='text'
                        onChange={this.updateQuestion}
                        onBlur={this.save}
                    />
                    <InputGroupAddon addonType='append'>
                        <Button color='danger' onClick={this.deleteQuestion}>
                            <i className={'fa fa-trash'}> </i>
                        </Button>
                    </InputGroupAddon>
                </InputGroup>
                {
                    isOpen &&
                    <div style={{'marginLeft': '1em', 'marginTop': '1em'}}>
                        <Row>
                            <Col lg={1}>
                                <Label>Punkte</Label>
                                <Input type='number' name='points' value={question.points} onChange={this.updateQuestion} onBlur={this.save}/>
                            </Col>
                        </Row>
                        <br/>
                        <Button color={'primary'} onClick={this.addNewAnswer}>
                            <i className={'fa fa-plus'}> </i> Antwort hinzufügen
                        </Button>
                        <br/>
                        {
                            question.answers.map((answer, idx) => (
                                <InputGroup key={`answer_${idx}`} style={{'marginTop': '1em'}}>
                                    <InputGroupAddon addonType='prepend'>
                                        <Button color='primary'>
                                            {answer.idx}.
                                        </Button>
                                    </InputGroupAddon>
                                    <Input type="text" value={answer.text} name='text' onChange={(e) => this.updateAnswerText(answer, e)} onBlur={this.save}/>
                                    <InputGroupAddon addonType='append'>
                                        {answer.correct &&
                                        <Button color='success' onClick={() => this.toggleAnswerCorrectness(answer, false)}>
                                            Richtig
                                        </Button>
                                        }
                                        {!answer.correct &&
                                        <Button color='warning' onClick={() => this.toggleAnswerCorrectness(answer, true)}>
                                            Falsch
                                        </Button>
                                        }
                                        <Button color='danger' onClick={() => this.deleteAnswer(answer)}>
                                            <i className={'fa fa-trash'}> </i>
                                        </Button>
                                    </InputGroupAddon>
                                </InputGroup>
                            ))
                        }
                    </div>
                }
            </Fragment>
        )
    }
}
